import { useTranslation } from "react-i18next";
import { buildWhatsappUrl } from "../../../../utils/FormatUtils";

const Whatsapp = (props) => {

    const { t } = useTranslation();
    const { phone, className = '' } = props;

    return (
        <a
            href={buildWhatsappUrl(phone)}
            target="_blank"
            rel="noreferrer"
            className={className}
            title={t('message.send_whatsapp_message')}
            aria-label={t('message.send_whatsapp_message')}
        >
            <i className="fa-brands fa-whatsapp fa-xl"></i>
        </a>
    );
}

export default Whatsapp;
